export default __webpack_public_path__ + "static/media/svg-5.564376c3.svg";